import { Location } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { TripRequestInfo } from '../../dashboard/models/trip-request-models';
import { LayoutService } from '../../shared/services/layout.service';
import { PostTripRequestComponent } from '../desktop-view/post-trip-request/post-trip-request.component';
import { PreTripRequestComponent } from '../desktop-view/pre-trip-request/pre-trip-request.component';
import { MobileViewPostTripRequestComponent } from '../mobile-view/post-trip-request/mobile-view-post-trip-request.component';
import { MobileViewPreTripRequestComponent } from '../mobile-view/pre-trip-request/mobile-view-pre-trip-request.component';

@Component({
  selector: 'trip-request-wrapper',
  standalone: true,
  imports: [PostTripRequestComponent, PreTripRequestComponent, MobileViewPostTripRequestComponent, MobileViewPreTripRequestComponent],
  templateUrl: './trip-request-wrapper.component.html',
})
export class TripRequestWrapperComponent implements OnInit {
  @Input() tripType: string = '';
  private location = inject(Location);
  tripRequest: TripRequestInfo | null = null;
  isMobileView = inject(LayoutService).isMobile;
  requestId = 0;
  mode = 'create';
  ngOnInit(): void {
    this.tripType = this.tripType.toLowerCase();
    const routerState = this.location.getState() as TripRequestInfo;
    if (routerState && routerState.requestId) {
      this.requestId = routerState.requestId;
      this.mode = routerState.mode;
    }
  }
}
